const TRADE_ROUTE_PREFIX = '/trade'
const FUTURES_ROUTE_PREFIX = '/futures'

export default defineNuxtRouteMiddleware((to) => {
  const isLegacyFuturesRoute =
    to.fullPath === FUTURES_ROUTE_PREFIX ||
    to.fullPath.startsWith(`${FUTURES_ROUTE_PREFIX}/`) ||
    to.fullPath.startsWith(`${FUTURES_ROUTE_PREFIX}?`) ||
    to.fullPath.startsWith(`${FUTURES_ROUTE_PREFIX}#`)

  if (isLegacyFuturesRoute) {
    const suffix = to.fullPath.slice(FUTURES_ROUTE_PREFIX.length)
    const normalizedSuffix = suffix.startsWith('/') ? suffix : `/${suffix}`

    const targetPath = `${TRADE_ROUTE_PREFIX}${normalizedSuffix.replace(
      /([^/?#])([?#])/,
      '$1/$2'
    )}`

    return navigateTo(targetPath)
  }

  if (to.fullPath.includes('?') && !to.fullPath.includes('/?')) {
    const [path, query] = to.fullPath.split('?')
    const newPath = `${path}/?${query}`

    return navigateTo(newPath)
  }
})
